import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import bannerImg from "./images/signup-side-banner.svg";
import { toast } from "react-toastify";
import { RiEyeOffFill, RiEyeFill } from "react-icons/ri";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Header from "./Header";

function Signup(props) {
  const navigate = useNavigate();
  // initializing stat
  const [signup, setSignUp] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // utiliity functions
  const handleChange = (event) => {
    setSignUp((prev) => ({
      ...prev,
      [event.target.name]: event.target.value,
    }));
  };

  // Handle error message
  const handleErrorMessage = (err) => {
    const error = err.message[0].msg || err.message;
    setErrorMessage(error);
  };

  const togglePasswordVisibilty = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      fullName: signup.fullName,
      email: signup.email,
      phoneNumber: signup.phoneNumber,
      password: signup.password,
    };
    // turn on the laoding
    setLoading(true);

    try {
      const response = await fetch(
        `https://studyapp-api.vercel.app/auth/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // "Access-Control-Allow-Origin": "*",
          },
          body: JSON.stringify(data),
        }
      );

      const userData = await response.json();

      console.log(userData);
      handleErrorMessage(userData);

      setSignUp((prev) => {
        return {
          ...prev,
          ...userData,
        };
      });
      setLoading(false);
    } catch (e) {
      toast.error(e);
      setLoading(false);
    }
  };

  return (
    <>
      {/* import header component */}
      <Header />

      <section className="signup-container">
        <div className="flex-2">
          <form className="form-container" onSubmit={handleSubmit}>
            <div className="form-wrapper">
              <div className="form-header">
                <h3>create an account</h3>
                <p>Let's get you started</p>
              </div>
              <div className="form-body">
                <div className="form-field">
                  <label htmlFor="fullName">
                    full name <span className="not-optional">*</span>
                  </label>
                  <input
                    type="text"
                    id="fullName"
                    name="fullName"
                    value={signup.fullName}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-field">
                  <label htmlFor="phoneNumber">
                    phone no <span className="not-optional">*</span>
                  </label>
                  <input
                    type="tel"
                    maxLength="11"
                    id="phoneNumber"
                    name="phoneNumber"
                    value={signup.phoneNumber}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-field">
                  <label htmlFor="email">
                    email <span className="not-optional">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={signup.email}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-field">
                  <label htmlFor="password">
                    password <span className="not-optional">*</span>
                  </label>
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    value={signup.password}
                    onChange={handleChange}
                  />
                  <span onClick={togglePasswordVisibilty} className="eye-icon">
                    {showPassword ? <RiEyeOffFill /> : <RiEyeFill />}
                  </span>
                </div>
              </div>
              {/* return error message*/}
              {signup.status === "success" ? (
                navigate("/register-successful")
              ) : (
                <span style={{ color: "red" }}>{errorMessage}</span>
              )}
              <div className="form-footer">
                <div className="form-field">
                  <div className="cta-btn">
                    <button>sign up</button>
                  </div>
                  {loading ? (
                    <Backdrop
                      sx={{
                        color: "#fff",
                        zIndex: (theme) => theme.zIndex.drawer + 1,
                      }}
                      open
                    >
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  ) : null}

                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "1.2rem",
                      fontWeight: "600",
                    }}
                  >
                    or
                  </p>
                </div>

                <div className="form-field google-btn">
                  <div className="cta-btn">
                    <button>
                      <span>sign up with google</span>
                    </button>
                  </div>

                  {""}
                  <p className="have-an-account">
                    Already have an account ?
                    <span className="login_signup">
                      <Link to="/login">Sign in</Link>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </form>
          <div className="side-banner-img">
            <img src={bannerImg} alt={"our users"} />
          </div>
        </div>
      </section>
    </>
  );
}

export default Signup;
